import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

import DatePicker, {
	DayValue,
	utils,
} from '@hassanmojab/react-modern-calendar-datepicker';
import fromUnixTime from 'date-fns/fromUnixTime';
import getDate from 'date-fns/getDate';
import getMonth from 'date-fns/getMonth';
import getUnixTime from 'date-fns/getUnixTime';
import getYear from 'date-fns/getYear';
import { useFormik } from 'formik';
import React from 'react';
import MultiSelect from 'react-multi-select-component';
import { Option } from 'react-multi-select-component/dist/lib/interfaces';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import * as Yup from 'yup';

import { getBrands } from '../../api/GET_brands';
import { getDetailScheduler } from '../../api/GET_detailScheduler';
import { getOutlets } from '../../api/GET_oulets';
import { postScheduler } from '../../api/POST_scheduler';
import { postUpdateScheduler } from '../../api/POST_updateScheduler';
import Alert from '../../components/Alert';
import CheckboxItem from '../../components/CheckboxItem';
import { checkboxValueBrand } from '../../components/CheckboxValue';
import ClearIndicator from '../../components/ClearIndicator';
import DropdownIndicator from '../../components/DropdownIndicator';
import Header from '../../components/Header';
import Layout from '../../components/Layout';
import ModalConfirmation from '../../components/ModalConfirmation';
import { AuthContext } from '../../context/authContext';
import { convertDay } from '../../utils/convertDay';
import { customStyles } from '../../utils/customStyles';
import { dateFormatter } from '../../utils/dateFormatter';
import { _retrieveLocalStorageItem } from '../../utils/localStorage';
import { day, statuses, times } from '../../utils/staticData';
import {
	Day,
	FormInventoryControl,
	Outlet,
	ParamsDetailScheduler,
	SchedulerBody,
	Status,
	Time,
} from './Home.type';

const Form = () => {
	const history = useHistory();
	const params = useParams();
	const newParams = params as ParamsDetailScheduler;
	const { id } = !!newParams && newParams;
	const { logout } = React.useContext(AuthContext);
	const [toggleDayMenu, setToogleDayMenu] = React.useState(false);
	const [toggleHourMenu, setToogleHourMenu] = React.useState(false);
	const [toggleStatus, setToogleStatus] = React.useState(false);

	const validationSchema = Yup.object().shape({
		selectedOutlet: Yup.object().shape({
			label: Yup.string().required(),
			value: Yup.string().required(),
		}),
		selectedBrand: Yup.array()
			.min(1)
			.of(
				Yup.object().shape({
					label: Yup.string().required(),
					value: Yup.string().required(),
				}),
			),
		startDate: Yup.object()
			.shape({
				day: Yup.number().required(),
				month: Yup.number().required(),
				year: Yup.number().required(),
			})
			.required(),
		selectedDay: Yup.object()
			.shape({
				label: Yup.string().required(),
				value: Yup.string().required(),
			})
			.required(),
		selectedTime: Yup.object()
			.shape({
				label: Yup.string().required(),
				value: Yup.string().required(),
			})
			.required(),
	});

	const [isBlocking, setIsBlocking] = React.useState(false);

	const { values, handleSubmit, resetForm, setFieldValue, errors } =
		useFormik<FormInventoryControl>({
			initialValues: {
				outlets: [],
				brands: [],
				selectedOutlet: null,
				selectedBrand: [],
				startDate: null,
				selectedDay: null,
				selectedTime: null,
				isLoading: false,
				isShowModalPrompt: false,
				isShowModalSubmit: false,
				isAlertVisible: false,
				errorMessage: '',
				inputErrorMessage: '',
				statuses: statuses,
				selectedStatus: null,
			},
			validateOnMount: true,
			validationSchema,
			onSubmit: async (formValues) => {
				const idOutlet = formValues.selectedOutlet.value;
				const outletName = formValues.selectedOutlet.label;
				const active = formValues.selectedStatus?.value;
				const currentDate = new Date(
					formValues.startDate.year,
					formValues.startDate.month - 1,
					formValues.startDate.day,
				);
				const startDate = getUnixTime(currentDate);

				const reminderDay = formValues.selectedDay.value;
				const reminderHour = formValues.selectedTime.value.toString();
				const dataBrand = formValues.selectedBrand.map((item) => {
					return { id: item.value, name: item.label };
				});

				const add: Omit<SchedulerBody, 'idScheduler' | 'active'> = {
					idOutlet,
					outletName,
					startDate,
					reminderDay,
					reminderHour,
					dataBrand,
				};

				const update: SchedulerBody = {
					idScheduler: +id,
					idOutlet,
					outletName,
					startDate,
					reminderDay,
					reminderHour,
					dataBrand,
					active,
				};

				if (id) {
					await postUpdateScheduler(update).then(
						({ status, messageDescription, messageData }) => {
							if (status === 'success') {
								setFieldValue('isLoading', false);
								setFieldValue('isShowModalSubmit', false);
								history.push('/success');
								resetForm({
									values: {
										outlets: [],
										brands: [],
										selectedOutlet: null,
										selectedBrand: [],
										startDate: null,
										selectedDay: null,
										selectedTime: null,
										isLoading: false,
										isShowModalPrompt: false,
										isShowModalSubmit: false,
										isAlertVisible: false,
										errorMessage: '',
										inputErrorMessage: '',
										statuses: statuses,
										selectedStatus: null,
									},
								});
							} else {
								setFieldValue('isAlertVisible', true);
								setFieldValue('isShowModalSubmit', false);
								setFieldValue('isLoading', false);
								setFieldValue('errorMessage', messageDescription);
								setFieldValue('inputErrorMessage', messageData);
							}
						},
					);
				} else {
					await postScheduler(add).then(
						({ status, messageDescription, messageData }) => {
							if (status === 'success') {
								setFieldValue('isLoading', false);
								setFieldValue('isShowModalSubmit', false);
								history.push('/success');
								resetForm({
									values: {
										outlets: [],
										brands: [],
										selectedOutlet: null,
										selectedBrand: [],
										startDate: null,
										selectedDay: null,
										selectedTime: null,
										isLoading: false,
										isShowModalPrompt: false,
										isShowModalSubmit: false,
										isAlertVisible: false,
										errorMessage: '',
										inputErrorMessage: '',
										statuses: statuses,
										selectedStatus: null,
									},
								});
							} else {
								setFieldValue('isAlertVisible', true);
								setFieldValue('isShowModalSubmit', false);
								setFieldValue('isLoading', false);
								setFieldValue('errorMessage', messageDescription);
								setFieldValue('inputErrorMessage', messageData);
							}
						},
					);
				}
			},
		});

	const cancelButtonRef = React.useRef(null);
	const toggleModalPrompt = React.useCallback(() => {
		setFieldValue('isShowModalPrompt', !values.isShowModalPrompt);
	}, [setFieldValue, values.isShowModalPrompt]);

	const toggleModalSubmit = () => {
		setFieldValue('isShowModalSubmit', !values.isShowModalSubmit);
	};
	const closeModalBackground = () => undefined;

	const CustomInputstartDate = ({ ref }) => (
		<div className="flex border rounded-xl p-4 border-gray-gray400">
			<input
				readOnly
				ref={ref}
				value={
					values.startDate
						? `${dateFormatter(
								new Date(
									values.startDate.year,
									values.startDate.month - 1,
									values.startDate.day,
								),
								'dd MMM yyyy',
						  )}`
						: 'Pilih Tanggal'
				}
				className="w-11/12 cursor-pointer outline-none text-gray-gray700 text-large font-interRegular"
			/>
			<img src="/images/calendar.svg" />
		</div>
	);

	const fetchDetailScheduler = React.useCallback(async () => {
		const { data, status } = await getDetailScheduler(+id);
		if (status === 'success') {
			const startDateFromUnixTime = fromUnixTime(data[0].startDate);
			const startDay = getDate(startDateFromUnixTime);
			const startMonth = getMonth(startDateFromUnixTime);
			const startYear = getYear(startDateFromUnixTime);
			const existingStartDate = {
				day: startDay,
				month: startMonth + 1,
				year: startYear,
			};

			const existingOutlets = {
				label: data.length > 0 && data[0].outletName,
				value: data.length > 0 && data[0].idOutlet,
			};

			const existingBrands =
				data.length > 0 &&
				data[0].brand.map((item) => {
					return {
						value: item.id,
						label: item.name,
					};
				});

			const convertReminderDay = convertDay(
				data.length > 0 && data[0].reminderDay,
			);
			const existingReminderDay = {
				label: convertReminderDay,
				value: data.length > 0 && data[0].reminderDay,
			};
			const existingReminderTime = {
				label: data.length > 0 && data[0].reminderHour,
				value: data.length > 0 && data[0].reminderHour,
			};

			const existingStatus = {
				label: data[0].active ? 'Aktif' : 'Nonaktif',
				value: data[0].active,
			};
			setFieldValue('selectedStatus', existingStatus);
			setFieldValue('selectedBrand', existingBrands);
			setFieldValue('selectedOutlet', existingOutlets);
			setFieldValue('startDate', existingStartDate);
			setFieldValue('selectedDay', existingReminderDay);
			setFieldValue('selectedTime', existingReminderTime);
		}
	}, [id, setFieldValue]);

	const fetchOutlets = React.useCallback(async () => {
		const { data, status } = await getOutlets();
		if (status === 'success') {
			const outlets =
				data &&
				data.length > 0 &&
				data.map((item) => {
					return {
						label: item.outletName,
						value: item.outletId,
					};
				});
			setFieldValue('outlets', outlets);
		}
	}, [setFieldValue]);

	const fetchBrands = React.useCallback(async () => {
		const { data, status } = await getBrands();
		if (status === 'success') {
			const brands =
				data &&
				data.length > 0 &&
				data.map((item) => {
					return {
						label: item.name,
						value: item.id,
					};
				});
			setFieldValue('brands', brands);
		}
	}, [setFieldValue]);

	const checkAccessLevel = React.useCallback(async () => {
		const accessLevel = await _retrieveLocalStorageItem('accessLevel');
		if (accessLevel !== 'InventoryControl') {
			logout();
		}
	}, [logout]);

	React.useEffect(() => {
		checkAccessLevel();
		fetchBrands();
		fetchOutlets();
		if (id) {
			fetchDetailScheduler();
		}
	}, [checkAccessLevel, fetchOutlets, fetchBrands, fetchDetailScheduler, id]);

	const onBackButtonEvent = React.useCallback(() => {
		if (isBlocking) {
			toggleModalPrompt();
		}
	}, [toggleModalPrompt, isBlocking]);

	React.useEffect(() => {
		window.history.pushState(null, null, window.location.pathname);
		window.addEventListener('popstate', onBackButtonEvent);
		return () => {
			window.removeEventListener('popstate', onBackButtonEvent);
		};
	}, [onBackButtonEvent]);

	const onToggleDayMenu = () => setToogleDayMenu(!toggleDayMenu);
	const onToggleHourMenu = () => setToogleHourMenu(!toggleHourMenu);
	const onToggleStatus = () => setToogleStatus(!toggleStatus);

	const onChangeOutlet = (selectedOutlet: Outlet) => {
		setFieldValue('selectedOutlet', selectedOutlet);
		setIsBlocking(selectedOutlet !== values.selectedOutlet);
	};

	const onChangeBrand = (selectedBrand: Array<Option>) => {
		setFieldValue('selectedBrand', selectedBrand);
		setIsBlocking(selectedBrand !== values.selectedBrand);
	};

	const onChangeStartDate = (value: DayValue) => {
		setFieldValue('startDate', value);
		setIsBlocking(value !== values.startDate);
	};

	const onChangeDay = (selectedDay: Day) => {
		setFieldValue('selectedDay', selectedDay);
		setIsBlocking(selectedDay !== values.selectedDay);
	};

	const onChangeTime = (selectedTime: Time) => {
		setFieldValue('selectedTime', selectedTime);
		setIsBlocking(selectedTime !== values.selectedTime);
	};

	const onChangeStatus = (selectedStatus: Status) => {
		setFieldValue('selectedStatus', selectedStatus);
		setIsBlocking(selectedStatus !== values.selectedStatus);
	};

	const onClickPrompt = () => {
		history.push('/inventory-control');
		setFieldValue('isShowModalPrompt', false);
	};

	const onClickSubmit = () => {
		setFieldValue('isLoading', true);
		handleSubmit();
	};

	const goBack = () => {
		if (isBlocking) {
			toggleModalPrompt();
		} else {
			history.push('/inventory-control');
		}
	};

	return (
		<div className="flex flex-col min-h-screen overflow-hidden">
			<ModalConfirmation
				icon="/images/warning.svg"
				title="Hapus Perubahan?"
				description="Apakah kamu yakin ingin menghapus perubahan yang telah dilakukan?"
				onClick={onClickPrompt}
				cancelButtonRef={cancelButtonRef}
				isShowModal={values.isShowModalPrompt}
				closeModal={toggleModalPrompt}
				closeModalBackground={closeModalBackground}
				isLoading={values.isLoading}
				variantButton="DOUBLE"
				textLeft="Batal"
				textRight="Ya, Hapus"
			/>
			<ModalConfirmation
				icon="/images/warning.svg"
				title="Simpan Penjadwalan"
				description="Penjadwalan stock take akan disimpan ke outlet yang dipilih. Yakin untuk menyimpan jadwal?"
				onClick={onClickSubmit}
				cancelButtonRef={cancelButtonRef}
				isShowModal={values.isShowModalSubmit}
				closeModal={toggleModalSubmit}
				closeModalBackground={closeModalBackground}
				isLoading={values.isLoading}
				variantButton="DOUBLE"
				textLeft="Batal"
				textRight="Simpan"
			/>
			<Header title="Yummy StockTake System" />
			<Layout>
				<section className="relative pb-14 laptop:mx-36 tablet:mx-10 mobile:mx-4">
					<div
						onClick={goBack}
						className="w-60 flex laptop:mt-32 tablet:mt-32 mobile:mt-28 mb-6 hover:cursor-pointer"
					>
						<img src="/images/arrowBack.svg" className="mr-4" />
						<div className="text-extraLarge2 text-gray-gray700 font-interMedium">
							{id ? 'Edit Jadwal' : 'Tambah Jadwal'}
						</div>
					</div>
					<div className="flex justify-center items-center">
						<div className="w-full max-w-md2">
							<div className="bg-white rounded-xl shadow-default p-6 mb-6">
								<div className="font-interMedium text-extraLarge text-gray-gray700 mb-6">
									Informasi Jadwal
								</div>
								<Alert
									showAlert={values.isAlertVisible}
									text={values.errorMessage}
								/>
								<form>
									<div className="mb-4">
										<div className="mb-3">
											<label className="text-medium font-interSemiBold text-gray-gray600 uppercase">
												Nama Outlet
											</label>
										</div>
										<div>
											<Select
												maxMenuHeight={158}
												isDisabled={id ? true : false}
												styles={customStyles}
												components={{
													ClearIndicator,
													DropdownIndicator,
													IndicatorSeparator: null,
												}}
												isClearable
												menuPortalTarget={document.body}
												name="outlet"
												options={values.outlets}
												noOp
												placeholder={
													values.selectedOutlet
														? values.selectedOutlet.label
														: 'Cari Outlet'
												}
												value={values.selectedOutlet}
												onChange={onChangeOutlet}
												noOptionsMessage={() => 'Pencarian tidak ditemukan'}
											/>
										</div>
									</div>
									<div className="mb-4">
										<div className="mb-3">
											<label className="text-medium font-interSemiBold text-gray-gray600 uppercase">
												Nama Brand
											</label>
										</div>
										<div>
											<MultiSelect
												ItemRenderer={CheckboxItem}
												valueRenderer={checkboxValueBrand}
												ArrowRenderer={() => (
													<img src="/images/chevronDown.svg" />
												)}
												ClearIcon={
													<img src="/images/cross.svg" className="mr-4" />
												}
												ClearSelectedIcon={
													<img src="/images/cross.svg" className="mr-3.5" />
												}
												options={values.brands}
												value={values.selectedBrand}
												className="rmsc"
												onChange={onChangeBrand}
												labelledBy="Pilih Brand"
												hasSelectAll
												selectAllLabel="Pilih Semua"
												overrideStrings={{
													allItemsAreSelected: 'Semua brand dipilih',
													clearSearch: 'Hapus Pencarian',
													noOptions: 'Pencarian tidak ditemukan',
													search: 'Cari Brand',
													selectSomeItems: 'Pilih Brand',
												}}
											/>
										</div>
									</div>
									<div className="mb-4">
										<div className="relative">
											<div className="mb-3">
												<label className="text-medium font-interSemiBold text-gray-gray600 uppercase">
													Tanggal Mulai
												</label>
											</div>
											<DatePicker
												value={values.startDate}
												onChange={onChangeStartDate}
												renderInput={CustomInputstartDate}
												inputPlaceholder={'Pilih Tanggal'}
												shouldHighlightWeekends
												minimumDate={utils('en').getToday()}
												colorPrimary="#006551"
												wrapperClassName="w-full"
												calendarTodayClassName="bg-positive-lighter"
											/>
										</div>
									</div>
									<div className="mb-4">
										<div className="mb-5">
											<label className="text-medium font-interSemiBold text-gray-gray600 uppercase">
												Waktu penjadwalan
											</label>
										</div>
										<div className="flex w-full space-x-4">
											<div className="w-1/2 relative">
												<div className="mb-3">
													<label className="text-large font-interRegular text-gray-gray600">
														Setiap Hari
													</label>
												</div>
												<Select
													isError={values.inputErrorMessage ? true : false}
													maxMenuHeight={242}
													isSearchable={false}
													components={{
														DropdownIndicator,
														IndicatorSeparator: null,
													}}
													placeholder="Pilih Hari"
													styles={customStyles}
													onMenuOpen={onToggleDayMenu}
													onMenuClose={onToggleDayMenu}
													options={day}
													onChange={onChangeDay}
													value={values.selectedDay}
												/>
											</div>
											<div className="w-1/2 relative">
												<div className="mb-3">
													<label className="text-large font-interRegular text-gray-gray600">
														Pada Jam
													</label>
												</div>
												<Select
													maxMenuHeight={242}
													isSearchable={false}
													components={{
														DropdownIndicator,
														IndicatorSeparator: null,
													}}
													placeholder="Pilih Jam"
													styles={customStyles}
													onMenuOpen={onToggleHourMenu}
													onMenuClose={onToggleHourMenu}
													options={times}
													onChange={onChangeTime}
													value={values.selectedTime}
												/>
											</div>
										</div>
										{values.inputErrorMessage && (
											<div className="text-medium font-interRegular text-danger-default my-4">
												{values.inputErrorMessage}
											</div>
										)}
									</div>
									{id && (
										<div className="mb-4">
											<div className="mb-3">
												<label className="text-medium font-interSemiBold text-gray-gray600 uppercase">
													Status Scheduler
												</label>
											</div>
											<div>
												<Select
													maxMenuHeight={242}
													isSearchable={false}
													components={{
														DropdownIndicator,
														IndicatorSeparator: null,
													}}
													styles={customStyles}
													onMenuOpen={onToggleStatus}
													onMenuClose={onToggleStatus}
													options={values.statuses}
													onChange={onChangeStatus}
													value={values.selectedStatus}
												/>
											</div>
										</div>
									)}
								</form>
							</div>
							<button
								disabled={Object.keys(errors).length > 0}
								onClick={toggleModalSubmit}
								type="submit"
								className={
									Object.keys(errors).length > 0
										? 'w-full bg-gray-gray300 rounded-xl flex items-center justify-center p-4 cursor-default'
										: 'w-full bg-primary-green rounded-xl flex items-center justify-center p-4 cursor-pointer'
								}
							>
								<div
									className={
										Object.keys(errors).length > 0
											? 'text-gray-gray500 text-large font-interSemiBold'
											: 'text-white text-large font-interSemiBold'
									}
								>
									Simpan Jadwal
								</div>
							</button>
						</div>
					</div>
				</section>
			</Layout>
		</div>
	);
};

export default Form;
